import { useState, useEffect } from "react";
import * as api from "middlewares/apis";
import { fetchingDataFromApi } from "actions/loaders";
import { useDispatch } from "react-redux";

const useAccountTransactions = (accountID, pageNum, limit, algoChain) => {
	const dispatch = useDispatch();
	const [transactions, setTransactions] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [hasMore, setHasMore] = useState(false);
	const [error, setError] = useState(false);

	useEffect(() => {
		setTransactions([]);
	}, []);

	useEffect(() => {
		getAccountTransactionsByID(accountID, pageNum, limit, algoChain);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [accountID, pageNum, limit, algoChain]);

	const getAccountTransactionsByID = async (accountID, pageNum, limit, algoChain) => {
		dispatch(fetchingDataFromApi(true));

		try {
			setIsLoading(true);
			setError(false);

			const { data } = await api.getAccountTransactionsByID(accountID, pageNum, limit, algoChain);

			if (data?.data) {
				setTransactions((prev) => {
					return [...new Set([...prev, ...data?.data?.transactions.map((transaction) => transaction)])];
				});

				setHasMore(data?.data?.transactions.length > 0);
				setIsLoading(false);
			} else {
				setHasMore(0);
				setIsLoading(false);
			}
		} catch (error) {
			console.error(error);
		}

		dispatch(fetchingDataFromApi(false));
	};

	const refreshTransactions = () => {
		setTransactions([]);
		setIsLoading(null);
		setHasMore(false);
		setError(false);

		getAccountTransactionsByID();
	};

	return { isLoading, error, transactions, hasMore, refreshTransactions };
};

export default useAccountTransactions;
